module.exports = __webpack_public_path__ + "static/media/stp_card_discover.81bdb2aa.png";